<script>
import HotelResult from './HotelResult.vue';
import shortid from 'shortid';

export default {
  components: {
    HotelResult,
  },
  props: {
    results: {
      type: Array,
      required: true,
    },
    showNearMeText: {
      type: String,
      required: true,
    }
  },
  computed: {
    noResults() {
      return !this.results || !this.results.length;
    },
    keyedResults() {
      return this.results.map(result => {
        return {
          ...result,
          key: shortid.generate(),
        };
      });
    },
  },
};
</script>

<template>
  <div class="hotel-search-results--content">
    <div class="results-header" @click="$emit('nearMe')">
      {{ showNearMeText }}
    </div>
    <div class="hotel-results">
      <HotelResult v-for="hotel in keyedResults" :key="hotel.key" :hotel="hotel"/>
      <div v-if="noResults" class="no-results">
        {{ $t('messages.noHotelsFound') }}
      </div>
    </div>
    <div :class="{ active: noResults }" class="results-footer">
      <span>{{ $t('messages.cantFindHotel') }} </span>
      <b class="d-inline-flex flex-row align-items-center" @click="$emit('bookDirectly')">
        {{ $t('actions.bookDirectly') }}
        <inline-svg
          :src="require('images/icons/arrow_right_grey.svg')"
          alt="Arrow right"
          class="arrow ms-4"
          height="16"
        ></inline-svg>
      </b>
    </div>
  </div>
</template>
